export const IkeEnvironment = {
	/**
	 * Local development environment
	 * No cloud resources should reference this environment
	 */
	LOCAL: 'local',

	/** Dev is the cloud environment intended to be linked to your local environment */
	DEV: 'dev',
	TEST: 'test',
	TEST2: 'test2',
	AUTOMATION: 'automation',
	STAGING: 'staging',

	PRODUCTION: 'production',
} as const;

export type IkeEnvironment =
	| typeof IkeEnvironment.LOCAL
	| typeof IkeEnvironment.DEV
	| typeof IkeEnvironment.TEST
	| typeof IkeEnvironment.TEST2
	| typeof IkeEnvironment.AUTOMATION
	| typeof IkeEnvironment.STAGING
	| typeof IkeEnvironment.PRODUCTION;

export function isIkeEnvironment(value: string): value is IkeEnvironment {
	return Object.values(IkeEnvironment)
		.map((env) => env.toString())
		.includes(value);
}
